/* eslint-disable max-len */
import React from 'react';
/* Components */
import Slider from './slider/Slider';
import Modal from '../../components/common/modal/modal';
// import UserService from '../../services/user-service';

export class Test extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modalOnboard: false,
      modalFallback: false,
      isFinishButtonClicked: false,
    };
  }

  toggleOnboardModal = () => {
    this.setState({
      modalOnboard: !this.state.modalOnboard,
    });
  };

  toggleFallbackModal = () => {
    this.setState({
      modalFallback: !this.state.modalFallback,
    });
  };

  handleCloseModal = (isFinishButtonClicked) => {
    this.setState({
      isFinishButtonClicked:
        typeof isFinishButtonClicked === 'boolean' ? isFinishButtonClicked : false,
    });

    this.toggleFallbackModal();
  };

  closeAndSave = () => {
    this.toggleFallbackModal();
    this.toggleOnboardModal();

    // send user preference
  };

  renderFallbackModal = () => {
    return (
      <Modal.Default isOpen={this.state.modalFallback} customClass="glu-slider-modal-finish">
        <div className="glu-modal__header glu-flex glu-flex-align-center">
          <div className="glu-modal__title glu-flex-grow">
            {this.state.isFinishButtonClicked
              ? 'Onboarding tutorial finished'
              : 'Skip onboarding tutorial'}
          </div>
          {!this.state.isFinishButtonClicked && (
            <div className="glu-flex-shrink">
              <button
                aria-label="close"
                type="button"
                className="glu-btn-link g-icon g-icon-close"
                onClick={this.toggleFallbackModal}
              />
            </div>
          )}
        </div>
        <div className="glu-modal__body">
          <div className="glu-content__section">
            <p className="glu-h5 text-secondary--line-height">
              In the &quot;Help&quot; menu, you can find the option for lunching Onboarding.
            </p>
          </div>
        </div>
        <footer className="glu-modal__footer">
          <div className="glu-flex-grow glu-flex-row">
            {!this.state.isFinishButtonClicked && (
              <div className="glu-flex-grow text-right">
                <button
                  type="button"
                  onClick={this.toggleFallbackModal}
                  className="glu-btn glu-btn--secondary"
                >
                  Cancel
                </button>
              </div>
            )}

            <div className="glu-flex-shrink">
              <button className="glu-btn glu-btn--primary" onClick={this.closeAndSave}>
                {this.state.isFinishButtonClicked ? 'Ok' : 'Ok, skip'}
              </button>
            </div>
          </div>
        </footer>
      </Modal.Default>
    );
  };

  async createNewTask() {
    // UserService.createNewTask();
    // UserService.getCreatedTasks();
    // UserService.removeTask();
    // const a = await UserService.getTaskListFeed();
    // console.log(a);
  }

  render() {
    return (
      <>
        <button className="glu-btn glu-btn--primary" onClick={this.createNewTask}>
          Open
        </button>
        <Modal.Default isOpen={this.state.modalOnboard} customClass="glu-slider-modal">
          <Slider closeModal={this.handleCloseModal} />
        </Modal.Default>

        {this.renderFallbackModal()}
      </>
    );
  }
}

export default Test;
